import { serialize as domFormSerializer } from "dom-form-serializer";

export const businessApplicationFormVueConfig = {
    el: '#business-application-form-app',
    data() {
        return {
            currentButtonLabel: '',
            currentStep: 1,
            errors: [],
            completed: false,
            steps: [],
            workingAreaBy: 'radius',
            workingAreaPostalCode: null,
            workingAreaRadiusInKilometers: null,
            workingAreaCenterLat: null,
            workingAreaCenterLng: null,
            circle: null,
            postalCode: ''
        }
    },
    methods: {
        initSteps() {
            let stepData = document.querySelectorAll('form .form-step');
            stepData.forEach((elem) => {
                this.steps.push({
                    step: Number(elem.dataset.step),
                    buttonLabel: elem.dataset.buttonLabel,
                });
            });
        },
        updateForm() {
            let stepData = this.steps.find(x => x.step === this.currentStep);
            this.currentButtonLabel = stepData.buttonLabel;
            this.clearErrors();
        },
        clearErrors() {
            this.errors = [];
            document.querySelectorAll('.is-invalid').forEach(elem => {
                elem.classList.remove('is-invalid');
            });
            document.querySelectorAll('.invalid-feedback').forEach(elem => {
                elem.classList.remove('d-block');
            });
        },
        showErrors() {
            Object.entries(this.errors).forEach(error => {
                let fieldName = error[0];
                let message = error[1];
                document.querySelectorAll(`[name="${fieldName}"]`).forEach(elem => {
                    if (elem.classList.contains('form-control')) {
                        elem.classList.add('is-invalid');
                    }

                    let feedbackElement = elem.closest('.form-group').querySelector('.invalid-feedback');
                    feedbackElement.innerText = message;
                    feedbackElement.classList.add('d-block');
                });
            });
        },
        modifyPostalCode(inputName) {
            switch (inputName) {
                case "workingAreaPostalCode":
                    this.workingAreaPostalCode = this.workingAreaPostalCode.replace(' ', '');
                    break;
                case "postalCode":
                    this.postalCode = this.postalCode.replace(' ', '');
                    break;
            }
        },
        submitForm() {
            this.clearErrors();
            axios
                .post(document.querySelector('form').action, domFormSerializer(document.querySelector('form')))
                .then(response => {
                    if (false === response.data.completed) {
                        ++this.currentStep;
                        this.updateForm();
                    }
                    else {
                        this.completed = true;
                    }
                })
                .catch(error => {
                    let errorResponseData = error.response.data;

                    if (errorResponseData.globalError === true) {
                        alert(errorResponseData.message);
                        return;
                    }

                    this.errors = errorResponseData.errors;
                })
        },
    },
    mounted() {
        this.initSteps();
        this.updateForm();
    },
    watch: {
        errors: function() {
            this.showErrors();
        },
    }
};
